<template>
  <v-card class="pa-4">
    <strong>{{ $t('Selecionar Equipamentos Filhos') }}</strong>

    <v-autocomplete
      hide-details="auto"
      v-model="equipmentIds"
      :items="equipments"
      multiple
      :item-text="(item) => `${item.identification} / ${item.name}`"
      item-value="id"
      :loading="equipmentsLoading"
      :rules="[(v) => !!v || 'Equipamento obrigatório']"
      outlined
      placeholder="Selecione os equipamentos"
      class="primary-input"
    >
      <template #message="{ message }">
        {{ $t(message) }}
      </template>
    </v-autocomplete>

    <div class="d-flex justify-end">
      <v-btn class="primary-button ma-0" depressed small @click="update">
        Salvar
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'
export default {
  name: 'SelectChildEquipment',

  props: {
    equipmentId: {
      type: Number,
      default: null,
    },
    childEquipmentIds: {
      type: Array,
      default: () => [],
    },
  },

  async created() {
    this.equipmentIds = this.childEquipmentIds
    await this.getEquipments()
  },

  data() {
    return {
      apiService: new ApiService(),
      equipmentIds: [],
      equipments: [],
      equipmentsLoading: false,
      loading: false,
    }
  },

  methods: {
    async getEquipments() {
      this.loading = true
      const institutionId = JSON.parse(localStorage.getItem('institution')).id

      await this.apiService
        .get(`equipment/list/${institutionId}`)
        .then((response) => {
          this.equipments = response.content.filter(
            (x) => x.id != this.equipmentId
          )
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    update() {
      this.loading = true
      const model = {
        equipmentId: this.equipmentId,
        childIds: this.equipmentIds,
      }

      this.apiService
        .post(`equipment/updateChilds`, model)
        .then(() => {
          this.$toast.success('Equipamentos filho atualizados com sucesso!')
          this.$emit('confirm')
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped></style>
